import Vue from 'vue'
import Router from 'vue-router'
const MainClient = () => import('@/views/layout/mainClient') //主框架

const login = () => import("@/views/login/login");
const overview = () => import("@/views/agentManagement/overview"); //概览
const flowOrderManagement = () => import("@/views/agentManagement/flowOrderManagement"); // 流量订单
const userManagement = () => import("@/views/agentManagement/userManagement"); // 流量订单
const applay = () => import("@/views/applay/applay"); //支付跳转页



Vue.use(Router)

const router = new Router({
  scrollBehavior: () => ({ y: 0 }),
  mode: 'history',
  routes: [{
    path: '/MainClient',
    name: 'MainClient',
    component: MainClient,
    children: [
      {
        path: "/applay",
        name: "applay",
        component: applay,
        meta: {
          title: ""
        }
      },
      // 概览
      {
        path: '/MainClient/overview',
        name: 'overview',
        component: overview,
        meta:{
          title:'starry代理商系统'
        }
      },
      {
        path: '/MainClient/flowOrderManagement',
        name: 'flowOrderManagement',
        component: flowOrderManagement,
        meta:{
          title:'starry代理商系统'
        }
      },
      {
        path: '/MainClient/userManagement',
        name: 'userManagement',
        component: userManagement,
        meta:{
          title:'starry代理商系统'
        }
      },
    ]
  },{
    path: "/login",
    name: "login",
    component: login,
    meta: {
      title: "starry代理商系统"
    }
  },{
    path: '/',
    redirect: '/login'
  }, {
    path: '*',
    redirect: '/login'
  }]
})
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js